import React from 'react';
import { Stack, Text } from '@pairy/pds-react';
import {
  FieldValues,
  UseFormGetValues,
  UseFormRegister,
  UseFormSetValue,
} from 'react-hook-form';

import { URLS } from '@/constants/layout';

import { Inputs } from '../Form';

import * as Styled from './index.styles';

interface CheckBoxProps<T extends FieldValues> {
  register: UseFormRegister<T>;
  getValues: UseFormGetValues<T>;
  setValue: UseFormSetValue<T>;
}

const CheckBox = ({ register, getValues, setValue }: CheckBoxProps<Inputs>) => {
  const handleTotalAgreeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      setValue('isDefaultAgree', true);
      setValue('isMarketingPolicyAccepted', true);
    } else {
      setValue('isDefaultAgree', false);
      setValue('isMarketingPolicyAccepted', false);
    }
  };

  const handleDefaultAgreeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked && getValues('isMarketingPolicyAccepted')) {
      setValue('isTotalAgree', true);
    } else {
      setValue('isTotalAgree', false);
    }
  };

  const handleMarketingPolicyAcceptedChange = (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    if (e.target.checked && getValues('isDefaultAgree')) {
      setValue('isTotalAgree', true);
    } else {
      setValue('isTotalAgree', false);
    }
  };

  return (
    <Styled.Container gap={8} direction="column" padding={16}>
      <Text variant="sm-semibold" as="label">
        <Stack gap={8} alignItems="center">
          <Styled.CheckBoxInput
            type="checkbox"
            {...register('isTotalAgree', {
              onChange: handleTotalAgreeChange,
            })}
          />
          전체 동의하기
        </Stack>
      </Text>

      <Styled.BorderLine />

      <Text variant="sm-semibold" as="label">
        <Stack gap={8} alignItems="center">
          <Styled.CheckBoxInput
            type="checkbox"
            {...register('isDefaultAgree', {
              required: '필수 동의 약관입니다',
              onChange: handleDefaultAgreeChange,
            })}
          />
          <div>
            <a
              target="_blank"
              href={URLS['privacyPolicyPage']}
              rel="noreferrer"
            >
              <Text variant="sm-semibold" color="skyblue_400">
                개인정보 처리 방침
              </Text>
            </a>
            을 확인하고 동의합니다 &nbsp;
            <Text variant="sm-semibold" color="skyblue_500">
              (필수)
            </Text>
          </div>
        </Stack>
      </Text>

      <Text variant="sm-semibold" color="zinc_400" as="label">
        <Stack gap={8}>
          <Styled.CheckBoxInput
            type="checkbox"
            {...register('isMarketingPolicyAccepted', {
              onChange: handleMarketingPolicyAcceptedChange,
            })}
          />
          <div>
            업데이트 소식, 프로모션 이벤트 등의 마케팅 목적의
            <br /> 수신을 동의합니다 (선택)
          </div>
        </Stack>
      </Text>
    </Styled.Container>
  );
};

export default CheckBox;
